export const GET_SITE_INFO = '[site] get site info';
export const PROCESS_SITE_INFO = '[site] process site info';
export const LOAD_SITE_INFO = '[site] load site info';
export const SITE_INFO_ERROR = '[site] site info error';
export const GET_SYS_PARAMS = '[site] get system parameters';
export const PROCESS_SYS_PARAMS = '[site] process system parameters';
export const LOAD_SYS_PARAMS = '[site] load system parameters';
export const SYS_PARAMS_ERROR = '[site] system parameters error';

export const getSiteInfo = () => ({
  type: GET_SITE_INFO,
});

export const processSiteInfo = (payload) => ({
  type: PROCESS_SITE_INFO,
  payload,
});

export const loadSiteInfo = (payload) => ({
  type: LOAD_SITE_INFO,
  payload,
});

export const siteInfoError = (payload) => ({
  type: SITE_INFO_ERROR,
  payload,
});

export const getSysParams = () => ({
  type: GET_SYS_PARAMS,
});

export const processSysParams = (payload) => ({
  type: PROCESS_SYS_PARAMS,
  payload,
});

export const loadSysParams = (payload) => ({
  type: LOAD_SYS_PARAMS,
  payload,
});

export const sysParamsError = (payload) => ({
  type: SYS_PARAMS_ERROR,
  payload,
});
